// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__14RJF","subheader":"ReorderModal_subheader__2usRu","listWrap":"ReorderModal_listWrap__2LEZl"};